import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Wrapper from "../../UI/Wrapper";
import axios from "axios";
import "../Graph/Graph.css";
import { DateRangePicker } from "react-date-range";

const Graph = () => {
  const [usersData, setUsersData] = useState([]);
  const [serviceTypeRegionData, setServiceTypeRegionData] = useState([]);
  const [dateRangeRegion, setdateRangeRegion] = useState("Select Date Range");
  const [isRegionLeadDataOpen, setisRegionLeadDataOpen] = useState(false);
  const [selectionRangeRegion, setselectionRangeRegion] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [loading, setLoading] = useState(false);

  const baseAPI = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const fetchGraphData = async () => {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      try {
        const response = await axios.get(
          `${baseAPI}userget/GetUsersGraphData?serviceType=${serviceTypeRegionData}&startdate=&enddate=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        if (response) {
          setUsersData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching user detail:", error);
      }
    };

    fetchGraphData();
  }, [serviceTypeRegionData]);

  const handleServiceTypeChange = (event) => {
    setServiceTypeRegionData(event.target.value);
  };

  const toggleRegionFilter = () => {
    setisRegionLeadDataOpen(!isRegionLeadDataOpen);
  };

  const handleSelectleadUser = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setselectionRangeRegion({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const regionFilterApplyButton = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = selectionRangeRegion.startDate
      ? formatDate(selectionRangeRegion.startDate)
      : "";
    let enddate = selectionRangeRegion.endDate
      ? formatDate(selectionRangeRegion.endDate)
      : "";

    if (startdate && enddate) {
      setdateRangeRegion(startdate + " - " + enddate);
    } else {
      setdateRangeRegion("Select Date Range");
    }

    if (storedToken) {
      setLoading(true);
      axios
        .get(
          `${baseAPI}userget/GetUsersGraphData?serviceType=${serviceTypeRegionData}&startdate=${startdate}&enddate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response) {
            setUsersData(response.data.data);
            setisRegionLeadDataOpen(!isRegionLeadDataOpen);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const closeButtonRegionData = () => {
    setisRegionLeadDataOpen(!isRegionLeadDataOpen);
  };

  return (
    <Wrapper className="graph">
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex" }}>
          <div style={{ padding: "13px" }}>
            <button
              style={{
                marginBottom: "1rem",
                width: "8rem",
                height: "2.5rem",
                borderRadius: "0.5rem",
                fontSize: "11px",
              }}
              onClick={toggleRegionFilter}
            >
              {" "}
              <b> {dateRangeRegion}</b>
            </button>
            {isRegionLeadDataOpen && (
              <div
                style={{
                  position: "absolute",
                  zIndex: 999,
                  border: "solid 1px black",
                  marginLeft: "-9pc",
                  width: "35pc",
                  background: "white",
                }}
              >
                <DateRangePicker
                  ranges={[selectionRangeRegion]}
                  onChange={handleSelectleadUser}
                />
                <button
                  onClick={regionFilterApplyButton}
                  style={{
                    marginBottom: "1rem",
                    width: "8rem",
                    height: "2.5rem",
                    borderRadius: "0.5rem",
                    fontSize: "13px",
                    position: "relative",
                    top: "1px",
                    left: "17pc",
                    backgroundColor: "#5B489D",
                    color: "White",
                    border: "none",
                  }}
                >
                  Apply Filter
                </button>
                <button
                  style={{
                    marginBottom: "1rem",
                    width: "7.5rem",
                    height: "2.5rem",
                    borderRadius: "0.5rem",
                    fontSize: "13px",
                    position: "relative",
                    top: "1px",
                    left: "17pc",
                    color: "red",
                    backgroundColor: "white",
                    border: "none",
                    fontWeight: "bold",
                  }}
                  onClick={closeButtonRegionData}
                >
                  Close
                </button>
              </div>
            )}
          </div>
          <div
            style={{
              height: "100px",
              // overflowY: "auto",
              marginTop: "6px",
              padding: "7px 8px 0 13px",
              width: "50%",
            }}
          >
            <select
              style={{
                marginBottom: "1rem",
                width: "8rem",
                height: "2.5rem",
                borderRadius: "0.5rem",
                fontSize: "13px",
                fontWeight: "bold",
              }}
              id="serviceType"
              name="serviceType"
              // value={regionListName}
              onChange={handleServiceTypeChange}
            >
              <option value=""> Service Type</option>
              <option value="International">International</option>
              <option value="Domestic">Domestic</option>
            </select>
          </div>
        </div>
        <div
          style={{
            overflowY: "auto",
            maxHeight: "calc(100vh + 200px)",
            overflowX: "auto",
            maxWidth: "calc(100vh + 300px)",
          }}
        >
          <div className="container-fluid">
            <div className="orderSummary" style={{ height: "13rem" }}>
              <table style={{ width: "100%", textAlign: "center" }}>
                <tr className="orderSummaryHeading">
                  <th className="leftAlign">Region</th>
                  <th>Leads</th>
                  <th>Bookings</th>
                  <th>Execution</th>
                </tr>
                <hr className="orderSummary" />
                {usersData.map((item) => (
                  <tr>
                    <td className="leftAlign">{item.region_name}</td>
                    <td>{item.Leads}</td>
                    <td>{item.Booking}</td>
                    <td>{item.Execution}</td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={490}>
            <BarChart
              width={600}
              height={400}
              data={usersData}
              margin={{
                top: 30,
                right: 30,
                left: 20,
                bottom: 5,
              }}
              barCategoryGap="20%"
              barGap="5%"
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="region_name" />
              {/* <YAxis /> */}
              <Tooltip />
              <Legend
                wrapperStyle={{ color: "black" }}
                className="custom-legend"
              />
              <Bar
                style={{ color: "black" }}
                dataKey="Leads"
                fill="#04B35A"
                stackId="a"
                barSize={30}
              />
              <Bar dataKey="Booking" fill="#A7E4C5" stackId="a" barSize={30} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Wrapper>
  );
};

export default Graph;
